// Formatting for the Activity log tab: what admins did while signed in as the
// user, beside everything else that happened in the account (DEV-1187).

export interface ActivityChange {
  subject: string;
  detail: string;
}

export interface ActivityEntry {
  id: string;
  actorName: string | null;
  actorEmail: string;
  entityType: string;
  action: string;
  entityId: string | null;
  changes: ActivityChange[];
  bySupport: boolean;
  impersonatorEmail: string | null;
  createdAt: string;
}

export interface ImpersonationSession {
  id: string;
  adminEmail: string;
  ip: string | null;
  userAgent: string | null;
  startedAt: string;
  expiresAt: string;
  endedAt: string | null;
}

export interface AuditEntry {
  id: string;
  operation: string;
  args: string | null;
  success: boolean;
  error: string | null;
  createdAt: string;
}

/** Who a feed line is by: the admin for support's lines, else the person. */
export const actorLabel = (entry: ActivityEntry): string =>
  entry.bySupport
    ? `${entry.impersonatorEmail ?? "Admin"} (as ${
        entry.actorName || entry.actorEmail
      })`
    : entry.actorName || entry.actorEmail;

export type SessionState = "open" | "ended" | "expired";

export const sessionState = (
  session: ImpersonationSession,
  now: Date = new Date(),
): SessionState => {
  if (session.endedAt) return "ended";
  return new Date(session.expiresAt) <= now ? "expired" : "open";
};

/** The arguments as the server stored them, indented for reading. */
export const prettyArgs = (args: string | null): string => {
  if (!args) return "";
  try {
    return JSON.stringify(JSON.parse(args), null, 2);
  } catch {
    return args;
  }
};
